import { useState } from 'react'
import { defineMessages, useIntl } from 'react-intl'
import { Button, Text, Box, Stack, useToast } from '@homebotapp/hb-react-component-catalog'
import { useVerificationFlow } from '../../VerificationFlowContext'
import { deleteTeamMembership } from '../../../../../store/slices/homebotNetwork/clientTeamMemberships'
import { useDispatch } from 'react-redux'
import { AppDispatch } from '../../../../../store'
import { useRemovePartnerStep } from '../../../../../hooks/homebotNetwork/verificationFlow/useRemovePartnerStep'

export const MSG = defineMessages({
  cancel: {
    id: 'VerificationFlow.RemovePartnerConfirmation.cancel',
    defaultMessage: 'Cancel'
  },
  descriptionLO: {
    id: 'VerificationFlow.RemovePartnerConfirmation.descriptionLO',
    defaultMessage: 'Are you sure you want to remove this loan officer?'
  },
  descriptionREA: {
    id: 'VerificationFlow.RemovePartnerConfirmation.descriptionREA',
    defaultMessage: 'Are you sure you want to remove this real estate agent?'
  },
  error: {
    id: 'VerificationFlow.RemovePartnerConfirmation.error',
    defaultMessage: 'Failed to remove partner'
  },
  remove: {
    id: 'VerificationFlow.RemovePartnerConfirmation.remove',
    defaultMessage: 'Yes, remove'
  }
})

/**
 * RemovePartnerView Component
 *
 * Placeholder for confirming partner removal.
 */
const RemovePartnerView = () => {
  const intl = useIntl()
  const toast = useToast()
  const { state } = useVerificationFlow()

  const { currentPartnerType } = state
  const { onCancel, removePartner, isLoading } = useRemovePartnerStep()

  const onRemove = async () => {
    try {
      await removePartner()
    } catch (error) {
      toast({
        description: intl.formatMessage(MSG.error),
        status: 'error'
      })
    }
  }

  const description =
    currentPartnerType === 'LoanOfficer'
      ? intl.formatMessage(MSG.descriptionLO)
      : intl.formatMessage(MSG.descriptionREA)

  return (
    <Box data-qa='remove-partner-view' data-testid='remove-partner-view'>
      <Text color='neutral.800'>{description}</Text>

      <Stack direction='row' gap={2} justifyContent='flex-end' mt='6'>
        <Button
          onClick={onCancel}
          tracking={{
            guid: 'ryoFtkSwiiqdU2924W9mv2',
            ui_context: 'verification_flow_remove_partner_view',
            descriptor: MSG.cancel.defaultMessage
          }}
        >
          {intl.formatMessage(MSG.cancel)}
        </Button>
        <Button
          colorScheme='danger'
          isLoading={isLoading}
          onClick={onRemove}
          tracking={{
            guid: 'ctWW8MdmSwfBXq25ru1Zjs',
            ui_context: 'verification_flow_remove_partner_view',
            descriptor: MSG.remove.defaultMessage
          }}
        >
          {intl.formatMessage(MSG.remove)}
        </Button>
      </Stack>
    </Box>
  )
}

export default RemovePartnerView
